// extracted by mini-css-extract-plugin
export default {"obfuscated":"obfuscate-text-module--obfuscated--7ec19"};